import { useState, useEffect } from 'react';
import axios from 'axios';
import { Star } from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL + '/api';

export const RatingDetails = ({ userId, isAdmin, isSelf, getAuthHeaders }) => {
  const [rating, setRating] = useState(null);

  useEffect(() => {
    axios.get(`${API}/tools/ratings/by-user/${userId}`, { headers: getAuthHeaders() })
      .then(res => setRating(res.data))
      .catch(() => {});
  }, [userId, getAuthHeaders]);

  if (!rating) return null;

  const labels = {
    disponibilidade: 'Disponibilidade',
    qualidade: 'Qualidade',
    som: 'Som',
    comprometimento: 'Comprometimento',
  };
  const ng = rating.nota_geral
    || ((rating.disponibilidade + rating.qualidade + rating.som + rating.comprometimento) / 4);

  return (
    <div className="bg-slate-700/30 border border-slate-600 rounded-lg p-4 mt-2">
      <div className="flex items-center gap-2 mb-3">
        <Star className="h-4 w-4 text-yellow-400 fill-yellow-400" />
        <span className="text-sm font-medium text-white">
          Avaliação - Nota Geral: <span className="text-yellow-400">{ng.toFixed(2)}/5</span>
        </span>
      </div>
      {(isAdmin || isSelf) && rating.disponibilidade !== undefined && (
        <div className="space-y-2">
          {Object.entries(labels).map(([key, label]) => (
            <div key={key} className="flex justify-between items-center">
              <span className="text-xs text-slate-400">{label}</span>
              <div className="flex items-center gap-1">
                {[1, 2, 3, 4, 5].map(s => (
                  <Star
                    key={s}
                    className={`h-3 w-3 ${s <= (rating[key] || 0) ? 'text-yellow-400 fill-yellow-400' : 'text-slate-600'}`}
                  />
                ))}
                <span className="text-xs text-slate-400 ml-1">{rating[key]}/5</span>
              </div>
            </div>
          ))}
          {rating.observacoes && (
            <p className="text-xs text-slate-500 mt-2 pt-2 border-t border-slate-600">
              {rating.observacoes}
            </p>
          )}
        </div>
      )}
    </div>
  );
};
